import axios from 'axios';
import {
  CREATE_ORDERS_SUCCESS,
  CREATE_ORDERS_FAIL,
  DELETE_ORDER_SUCCESS,
  DELETE_ORDER_FAIL,
  FETCH_ORDERS_SUCCESS,
  FETCH_ORDERS_FAIL,
  FETCH_LATEST_ORDERS_SUCCESS,
  FETCH_LATEST_ORDERS_FAIL,
  FETCH_OPEN_ORDERS_SUCCESS,
  FETCH_OPEN_ORDERS_FAIL,
  FETCH_ORDER_LIQUIDITY_SUCCESS,
  FETCH_EXCHANGE_RATE_SUCCESS,
  FETCH_EXCHANGE_RATE_FAIL,
  FETCH_ASSET_VALUE_SUCCESS,
  FETCH_ASSET_VALUE_FAIL,
  FETCH_QUOTE_SUCCESS,
  FETCH_QUOTE_FAIL,
  CREATE_OTC_ORDER_SUCCESS,
  CREATE_OTC_ORDER_FAIL,
  FETCH_TST_QUOTE_SUCCESS,
  FETCH_TST_QUOTE_FAIL,
  CREATE_TST_ORDER_SUCCESS,
  CREATE_TST_ORDER_FAIL,
  FETCH_TST_SUPPLY_SUCCESS,
  FETCH_TST_SUPPLY_FAIL,
  FETCH_TST_ASSET_VALUE_SUCCESS,
  FETCH_TST_ASSET_VALUE_FAIL,
} from './types';

export const fetchOrders = (params) => async (dispatch) => {
  let url = process.env.REACT_APP_API_URL + '/private/orders';
  if (params.liquidity) {
    url += '/liquidity';
  }
  let TYPE = FETCH_ORDERS_SUCCESS;
  if (params.liquidity) {
    TYPE = FETCH_ORDER_LIQUIDITY_SUCCESS;
  }
  try {
    const response = await axios.get(url, { params });
    return dispatch({ type: TYPE, payload: response.data.data, typeHandle: params.type });
  } catch (error) {
    if (error) {
      return dispatch({ type: FETCH_ORDERS_FAIL, errors: error });
    }
    return dispatch({ type: FETCH_ORDERS_FAIL });
  }
};

export const fetchLatestOrders = (params) => async (dispatch) => {
  let url = process.env.REACT_APP_API_URL + '/private/trades';
  try {
    const response = await axios.get(url, { params });
    return dispatch({ type: FETCH_LATEST_ORDERS_SUCCESS, payload: response.data.data });
  } catch (error) {
    if (error) {
      return dispatch({ type: FETCH_LATEST_ORDERS_FAIL, errors: error });
    }
    return dispatch({ type: FETCH_LATEST_ORDERS_FAIL });
  }
};

export const fetchOpenOrders = (params) => async (dispatch) => {
  const url = process.env.REACT_APP_API_URL + '/private/orders';
  try {
    const response = await axios.get(url, { params });
    return dispatch({ type: FETCH_OPEN_ORDERS_SUCCESS, payload: response.data.data });
  } catch (error) {
    if (error) {
      return dispatch({ type: FETCH_OPEN_ORDERS_FAIL, errors: error });
    }
    return dispatch({ type: FETCH_OPEN_ORDERS_FAIL });
  }
};

export const createOrder = (data) => async (dispatch) => {
  const url = process.env.REACT_APP_API_URL + '/private/orders';
  try {
    const response = await axios.post(url, data);
    return dispatch({ type: CREATE_ORDERS_SUCCESS, payload: response.data.data });
  } catch (error) {
    if (error) {
      return dispatch({ type: CREATE_ORDERS_FAIL, errors: error });
      // return toast.error(error.response.data.errors[0]);
    }
    return dispatch({ type: CREATE_ORDERS_FAIL });
  }
};

export const deleteOrder = (id) => async (dispatch) => {
  const url = process.env.REACT_APP_API_URL + '/private/orders/' + id;
  try {
    const response = await axios.delete(url);
    return dispatch({ type: DELETE_ORDER_SUCCESS, payload: response.data.data });
  } catch (error) {
    if (error) {
      return dispatch({ type: DELETE_ORDER_FAIL, errors: error });
    }
    return dispatch({ type: DELETE_ORDER_FAIL });
  }
};

export const fetchExchangeRate = (data) => async (dispatch) => {
  const url = process.env.REACT_APP_API_URL + '/private/orders/quote';
  try {
    const response = await axios.post(url, data);
    return dispatch({ type: FETCH_EXCHANGE_RATE_SUCCESS, payload: response.data });
  } catch (error) {
    if (error) {
      return dispatch({ type: FETCH_EXCHANGE_RATE_FAIL, errors: error });
    }
    return dispatch({ type: FETCH_EXCHANGE_RATE_FAIL });
  }
};

export const fetchAssetValue = (params) => async (dispatch) => {
  const url = process.env.REACT_APP_API_URL + '/public/ticker';
  try {
    const response = await axios.get(url, { params });
    return dispatch({ type: FETCH_ASSET_VALUE_SUCCESS, payload: response.data });
  } catch (error) {
    if (error) {
      return dispatch({ type: FETCH_ASSET_VALUE_FAIL, errors: error });
    }
    return dispatch({ type: FETCH_ASSET_VALUE_FAIL });
  }
};

export const fetchTstAssetValue = (params) => async (dispatch) => {
  const url = process.env.REACT_APP_API_URL + '/public/ticker';
  try {
    const response = await axios.get(url, { params });
    return dispatch({ type: FETCH_TST_ASSET_VALUE_SUCCESS, payload: response.data });
  } catch (error) {
    if (error) {
      return dispatch({ type: FETCH_TST_ASSET_VALUE_FAIL, errors: error });
    }
    return dispatch({ type: FETCH_TST_ASSET_VALUE_FAIL });
  }
};

export const fetchQuote = (data) => async (dispatch) => {
  const url = process.env.REACT_APP_API_URL + '/private/orders/otc';
  try {
    const response = await axios.post(url, data);
    return dispatch({ type: FETCH_QUOTE_SUCCESS, payload: response.data.data });
  } catch (error) {
    if (error) {
      return dispatch({ type: FETCH_QUOTE_FAIL, errors: error });
    }
    return dispatch({ type: FETCH_QUOTE_FAIL });
  }
};

export const createOtcOrder = (data) => async (dispatch) => {
  const url = process.env.REACT_APP_API_URL + '/private/orders/otc';
  try {
    const response = await axios.post(url, data);
    return dispatch({ type: CREATE_OTC_ORDER_SUCCESS, payload: response.data.data });
  } catch (error) {
    if (error) {
      return dispatch({ type: CREATE_OTC_ORDER_FAIL, errors: error });
    }
    return dispatch({ type: CREATE_OTC_ORDER_FAIL });
  }
};

export const fetchTstQuote = (data) => async (dispatch) => {
  const url = process.env.REACT_APP_API_URL + '/private/orders/tst';
  try {
    const response = await axios.post(url, data);
    return dispatch({ type: FETCH_TST_QUOTE_SUCCESS, payload: response.data.data });
  } catch (error) {
    if (error) {
      return dispatch({ type: FETCH_TST_QUOTE_FAIL, errors: error });
    }
    return dispatch({ type: FETCH_TST_QUOTE_FAIL });
  }
};

export const createTstOrder = (data) => async (dispatch) => {
  const url = process.env.REACT_APP_API_URL + '/private/orders/tst';
  try {
    const response = await axios.post(url, data);
    return dispatch({ type: CREATE_TST_ORDER_SUCCESS, payload: response.data.data });
  } catch (error) {
    if (error) {
      return dispatch({ type: CREATE_TST_ORDER_FAIL, errors: error });
    }
    return dispatch({ type: CREATE_TST_ORDER_FAIL });
  }
};

export const fetchTstSupply = (params) => async (dispatch) => {
  const url = process.env.REACT_APP_API_URL + '/orders/tstSupply';
  try {
    const response = await axios.get(url, { params });
    return dispatch({ type: FETCH_TST_SUPPLY_SUCCESS, payload: response.data });
  } catch (error) {
    if (error) {
      return dispatch({ type: FETCH_TST_SUPPLY_FAIL, errors: error });
    }
    return dispatch({ type: FETCH_TST_SUPPLY_FAIL });
  }
};
